/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Searchplaceholder2Inputs */

const zh_adminthreads_searchplaceholder2 = /** @type {(inputs: Adminthreads_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索对话标题...`)
};

const en_adminthreads_searchplaceholder2 = /** @type {(inputs: Adminthreads_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search conversation titles...`)
};

const es_adminthreads_searchplaceholder2 = /** @type {(inputs: Adminthreads_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar títulos de conversaciones...`)
};

/**
* | output |
* | --- |
* | "Search conversation titles..." |
*
* @param {Adminthreads_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_searchplaceholder2 = /** @type {((inputs?: Adminthreads_Searchplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Searchplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_searchplaceholder2(inputs)
	if (locale === "en") return en_adminthreads_searchplaceholder2(inputs)
	return es_adminthreads_searchplaceholder2(inputs)
});
export { adminthreads_searchplaceholder2 as "adminThreads_searchPlaceholder" }